export const logout = () => {
    // Clear all session storage
    sessionStorage.clear();
    
    // Or clear specific items
    const keysToRemove = [
        'isLoggedIn',
        'LoggedInName',
        'LoggedInEmail',
        'LoggedInUserId',
        'LoggedInToken',
        'LoggedInCompanyId',
        'LoggedInDivisionId',
        'LoggedInOtherDivisionIds',
        'LoggedInDepartmentId',
        'LoggedInModuleId',
        'LoggedInSubModuleId',
        'LoggedInRoleName',
        'LoggedInCompanyName',
        'LoggedInCompanyShortName',
        'LoggedInDivisionName',
        'LoggedInDivisionShortName',
        'LoggedInDepartmentName',
        'LoggedInDepartmentShortName',
        'CurrentCompanyId',
        'CurrentDivisionId',
        'CurrentDepartmentId',
        'CurrentCompanyName',
        'CurrentDivisionName',
        'CurrentDepartmentName'
    ];
    
    keysToRemove.forEach(key => sessionStorage.removeItem(key));
    
    // Redirect to login
    window.location.href = '/login';
};